import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { moduleLinkFor } from '../constants/screen-registry';
import { ShellNavItem } from '../models/shell-nav-item';

@Injectable({
  providedIn: 'root'
})
export class CatalogNavigationService {
  private readonly router = inject(Router);

  isActive(item: ShellNavItem, url: string): boolean {
    if (item.screenKind === 'Url') {
      return url.startsWith(`/module/${item.rowKey}`);
    }

    const link = moduleLinkFor(item).join('/').replace('//', '/');
    return url === link || url.startsWith(`${link}?`);
  }

  open(item: ShellNavItem): void {
    if (item.screenKind === 'Url' && item.openMode === 'NewTab' && item.targetUrl) {
      window.open(item.targetUrl, '_blank', 'noopener');
      return;
    }

    if (item.screenKind === 'Url' && item.openMode === 'SameWindow' && item.targetUrl) {
      window.location.assign(item.targetUrl);
      return;
    }

    void this.router.navigate(moduleLinkFor(item));
  }
}
